module.exports = __webpack_public_path__ + "static/img/logo-mediheal.fccf7e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/logo-mediheal.png
// module id = pX2H
// module chunks = 0